/**
 * This file is for WIP copy that needs to be translated.
 * Finalized copy belongs in the `copy/final.ts` file.
 * Please use consistent naming - the key will be the same as the key in the final file.
 * Please group blocks of WIP copy with a link to a JIRA ticket to track finalizing and translating them.
 */

/**
 * Sparkle Button First Load Notification: https://vimean.atlassian.net/browse/AI-4302
 */
export const tryVimeoAi = 'Try Vimeo AI';

/**
 * Highlight Strings: https://vimean.atlassian.net/browse/AI-4079
 */
export const highlightsFailed = 'Highlights failed';
export const saving = 'Saving...';
export const open = 'Open';
export const edit = 'Edit';
export const saveAndEditAsNewVideo = 'Save and edit as new video';
export const failedSavingHighlight = 'Failed saving the highlight, please try again later';
export const successfullySavedHighlight = 'Successfully saved a video';
export const moment = 'Moment';
export const highlightsVideoResolutionTooLow =
  'This feature only supports videos of resolution 360p or larger';
// End Highlight

/**
 * Q&A Strings
 */
export const generateQnaForViewers = 'Generate Q&A for viewers';
export const qnaFailed = 'Q&A failed';
export const qnaInterractionsLimitError = 'Unable to process your request. Try again later.';

/**
 * AI Settings strings: https://vimean.atlassian.net/browse/AI-4080
 */
export const someTranslationsSaved = 'Some translations saved';
export const translationsFailed = 'Translations failed';
// End AI Settings
